// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPatientAddressModel } from './eServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPatientAddressModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPatientModel {
    /**
    * @description Gets or sets the date of birth.
    */
    'dateOfBirth'?: string | null;
    /**
    * @description Gets or sets the first name.
    */
    'firstName'?: string | null;
    /**
    * @description Gets or sets the last name.
    */
    'lastName'?: string | null;
    'address'?: EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPatientAddressModel | null;
    /**
    * @description Gets or sets the phone.
    */
    'phone'?: string | null;
    /**
    * @description Gets or sets the middle name.
    */
    'middleName'?: string | null;
    /**
    * @description Gets or sets the suffix.
    */
    'suffix'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPatientModel>> = [
        {
            "name":     "dateOfBirth",
            "baseName": "dateOfBirth",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPatientAddressModel"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "suffix",
            "baseName": "suffix",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPatientModel.attributeTypeMap;
    }
}
